module.exports = __webpack_public_path__ + "static/media/icon_2smile.8d75e6f4.svg";